<div [innerHtml]="data"></div>
<br/>
<br/>
<p-footer>
    <button type="button" pButton icon="ui-icon-cancel" label="Annuler" class="ui-button-secondary mr-12" (click)="close()"></button>
    <button type="button" pButton icon="ui-icon-check" label="Confirmer" (click)="execute()"></button>
</p-footer>
